import React from "react";
import { Link } from 'react-router-dom';
import { Opacity } from 'components';
import i5a from 'assets/images/i5a.svg';
import i42 from 'assets/images/i42.svg';
import i51a from 'assets/images/i51a.svg';
import i77a from 'assets/images/i77a.svg';
import i3a from 'assets/images/i3a.svg';
import i30 from 'assets/images/i30.svg';
import i19 from 'assets/images/i19.svg';
import i86a from 'assets/images/i86a.svg';
import i87a from 'assets/images/i87a.svg';
import i84 from 'assets/images/i84.svg';
import i29 from 'assets/images/i29.svg';

const propTypes = {
};

class LinksPopup extends React.Component {
  shouldComponentUpdate() {
    return false;
  }
  render() {
    return (
      <div className="nav-toppanel--options-dropdown">
        <div className="nav-toppanel--options-link-list">
          <div className="nav-toppanel--options-link">
            <h6>
              <span className="category-icon">
                <img src={i5a} alt="" />
              </span>
              <span>Zamówienia</span>
            </h6>
            <Link to="/orders/creator">
              <span className="category-icon">
                <img src={i42} alt="" />
              </span>
              <span className="link-name">Utwórz zamówienie</span>
            </Link>
            <Link to="/sets/add">
              <span>
                <img src={i86a} alt="" />
              </span>
              <span className="link-name">Ostatnio utworzone</span>
            </Link>
          </div>
          <div className="nav-toppanel--options-link">
            <h6>
              <span className="category-icon">
                <img src={i51a} alt="" />
              </span>
              <span>Trasy</span>
            </h6>
            <Link to="/routes/creator">
              <span>
                <img src={i42} alt="" />
              </span>
              <span className="link-name">Utwórz trasę</span>
            </Link>
            <Link to="/sets/add">
              <span>
                <img src={i86a} alt="" />
              </span>
              <span className="link-name">Ostatnio utworzone</span>
            </Link>
          </div>
          <div className="nav-toppanel--options-link">
            <h6>
              <span className="category-icon">
                <img src={i77a} alt="" />
              </span>
              <span>Firmy</span>
            </h6>
            <Link to="/companies/add">
              <span>
                <img src={i42} alt="" />
              </span>
              <span className="link-name">Dodaj firmę</span>
            </Link>
            <Link to="/sets/add">
              <span>
                <img src={i86a} alt="" />
              </span>
              <span className="link-name">Ostatnio dodane</span>
            </Link>
          </div>
          <div className="nav-toppanel--options-link">
            <h6>
              <span className="category-icon">
                <img src={i3a} alt="" />
              </span>
              <span>Użytkownicy</span>
            </h6>
            <div style={{position: 'relative'}}>
              <Link to="/" disabled>
                <span>
                  <img src={i42} alt="" />
                </span>
                <span className="link-name">Dodaj użytkownika</span>
              </Link>
              <Link to="/sets/add">
                <span>
                  <img src={i86a} alt="" />
                </span>
                <span className="link-name">Ostatnio dodani</span>
              </Link>
              <Opacity active color="250,250,250" density={0.9} />
            </div>
          </div>
          <div className="nav-toppanel--options-link">
            <h6>
              <span className="category-icon">
                <img src={i3a} alt="" />
              </span>
              <span>Kierowcy</span>
            </h6>
            <Link to="/drivers/add">
              <span>
                <img src={i42} alt="" />
              </span>
              <span className="link-name">Dodaj kierowcę</span>
            </Link>
            <Link to="/sets/add">
              <span>
                <img src={i86a} alt="" />
              </span>
              <span className="link-name">Ostatnio dodani</span>
            </Link>
          </div>
          <div className="nav-toppanel--options-link">
            <h6>
              <span className="category-icon">
                <img src={i30} alt="" />
              </span>
              <span>Samochody</span>
            </h6>
            <Link to="cars/add">
              <span>
                <img src={i42} alt="" />
              </span>
              <span className="link-name">Dodaj samochód</span>
            </Link>
            <Link to="/sets/add">
              <span>
                <img src={i86a} alt="" />
              </span>
              <span className="link-name">Ostatnio dodane</span>
            </Link>
          </div>
          <div className="nav-toppanel--options-link">
            <h6>
              <span className="category-icon">
                <img src={i19} alt="" />
              </span>
              <span>Asortyment</span>
            </h6>
            <Link to="/sets/add">
              <span>
                <img src={i42} alt="" />
              </span>
              <span className="link-name">Dodaj produkt</span>
            </Link>
            <Link to="/sets/add">
              <span>
                <img src={i86a} alt="" />
              </span>
              <span className="link-name">Ostatnio dodane</span>
            </Link>
            <Link to="/sets/add">
              <span>
                <img src={i42} alt="" />
              </span>
              <span className="link-name">Utwórz zestaw</span>
            </Link>
            <Link to="/sets/add">
              <span>
                <img src={i86a} alt="" />
              </span>
              <span className="link-name">Ostatnio utworzone</span>
            </Link>
          </div>
          <div className="nav-toppanel--options-link">
            <h6>
              <span className="category-icon">
                <img src={i29} alt="" />
              </span>
              <span>Realizacje</span>
            </h6>
            <Link to="/sets/add">
              <span>
                <img src={i86a} alt="" />
              </span>
              <span className="link-name">Ostatnio utworzone</span>
            </Link>
            <Link to="/sets/add">
              <span>
                <img src={i86a} alt="" />
              </span>
              <span className="link-name">Ostatnio dostarczone</span>
            </Link>
          </div>
          <div className="nav-toppanel--options-link">
            <h6>
              <span className="category-icon">
                <img src={i84} alt="" />
              </span>
              <span>Tapicerka</span>
            </h6>
            <Link to="/sets/add">
              <span>
                <img src={i86a} alt="" />
              </span>
              <span className="link-name">Ostatnio utworzone</span>
            </Link>
            <Link to="/sets/add">
              <span>
                <img src={i86a} alt="" />
              </span>
              <span className="link-name">Ostatnio dostarczone</span>
            </Link>
          </div>
          <div className="nav-toppanel--options-link">
            <h6>
              <span className="category-icon">
                <img src={i87a} alt="" />
              </span>
              <span>Reklamacje</span>
            </h6>
            <Link to="/sets/add">
              <span>
                <img src={i86a} alt="" />
              </span>
              <span className="link-name">Utwórz reklamację</span>
            </Link>
            <Link to="/sets/add">
              <span>
                <img src={i86a} alt="" />
              </span>
              <span className="link-name">Ostatnio utworzone</span>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

LinksPopup.propTypes = propTypes;
export default LinksPopup;



// WEBPACK FOOTER //
// ./src/partialComponents/panelWrapper/subcomponents/LinksPopup.jsx